import {
  Button,
  Col,
  Form,
  Row,
  Input,
  message,
  DatePicker,
  Select,
  Spin,
} from "antd";
import React, { useState } from "react";
import moment from "moment";
import { ImportStatus, ReceiptType } from "_helpers";
import { stockReceiptService } from "_services";

function Search(props) {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    props.showSearchLoading(true);

    let paramList = [];

    if (values.customRefNumber) {
      paramList.push(
        `customRefNumber=${encodeURIComponent(values.customRefNumber)}`
      );
    }

    if (values.purchaseOrderNumber) {
      paramList.push(
        `receiptNumber=${encodeURIComponent(values.purchaseOrderNumber)}`
      );
    }

    if (values.receiptType) {
      paramList.push(
        `receiptType=${encodeURIComponent(values.receiptType.toString())}`
      );
    }

    if (values.orderStage) {
      paramList.push(
        `orderStage=${encodeURIComponent(values.orderStage.join(","))}`
      );
    }

    if (values.orderDateRange) {
      paramList.push(
        `fromDate=${encodeURIComponent(
          moment(values.orderDateRange[0]).startOf("day").format("YYYY-MM-DD")
        )}&toDate=${moment(values.orderDateRange[1])
          .startOf("day")
          .format("YYYY-MM-DD")}`
      );
    }

    const searchParams = paramList.length ? `?${paramList.join("&")}` : "";

    stockReceiptService
      .search(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content,
          data.pagination.totalRecords,
          searchParams
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });
  };

  return (
    <Spin tip="Loading..." spinning={loading}>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        className="search-form"
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item name="customRefNumber" label="CUS. DEC. NO#">
              <Input.Search placeholder="Customs Ref. Number" allowClear />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="purchaseOrderNumber" label="Receipt Number">
              <Input.Search placeholder="Receipt number" allowClear />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="orderDateRange" label="Receipt Date">
              <DatePicker.RangePicker
                ranges={{
                  Today: [moment(), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                }}
              />
            </Form.Item>
          </Col>

          <Col span={6} style={{ textAlign: "right" }}>
            <div>
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{ margin: "0 8px" }}
                onClick={() => {
                  form.resetFields();
                  onFinish({});
                }}
              >
                Clear
              </Button>
            </div>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item name="receiptType" label="Import Type">
              <Select
                showSearch
                allowClear
                showArrow={false}
                optionFilterProp="children"
                placeholder="Import Type"
              >
                {ReceiptType.map((item) => (
                  <Select.Option value={item.value}>{item.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="orderStage" label="Status">
              <Select allowClear mode="multiple">
                {ImportStatus.map((t) => (
                  <Select.Option value={t.value} key={t.value}>
                    {t.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}></Col>
          <Col span={6}></Col>
        </Row>
      </Form>
    </Spin>
  );
}

export default Search;
